import React from 'react';

function getAnchor(document = window.document) {
    const linkElements = document.getElementsByTagName('LINK');
    const suiLink = document.querySelector('link[href*="sui"]');

    if (suiLink) {
        return suiLink;
    } else if (linkElements.length) {
        const firstStyleTag = linkElements.item(0);
        return firstStyleTag;
    } else {
        return document.head;
    }
}

/**
 * HOC to insert the anchor for styled components tag on component creation.
 */
export default (WrappedComponent) =>
    class WithInlineStylesAnchor extends React.Component {
        constructor(props) {
            super(props);

            this.anchor = getAnchor();
        }
        render() {
            return <WrappedComponent target={this.anchor} {...this.props} />;
        }
    };
